<template>
    <div class="page-atleti-detail">
      <utente-detail />
    </div>
  </template>
  
  <script>
  import UtenteDetail from '@/components/details/UtenteDetail.vue'
  
  export default {
    name: 'ViewUtenteDetail',
    components: {
      UtenteDetail,
    },
  
    data() {
      return {
        pageName: 'UtenteDetail',
      }
    },
  
    created(){
  
    },
  
    mounted(){
      this.$eventBus.emit('page-change', {
        target: this,
        currentRoute: this.$router.currentRoute.value
      })
    },
    
  }
  </script>